import script from "./ActionButon.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionButon.vue?vue&type=script&setup=true&lang=js"

import "./ActionButon.vue?vue&type=style&index=0&id=143ba154&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-143ba154"]])

export default __exports__